import {ApiClient} from "../utils/apiClient";
import {USER_ERROR, AlertTypes} from "@leap4/frontend";
import {setAlert} from "./alert"
import {Dispatch} from "redux";
import {
    createNewOrganizationUrl,
    deleteOwnershipUrl,
    OrganizationsBaseUrl,
    OrganizationsSubmitChanges, OrganizationsUpdatePartners, ownershipsSupply,
    AddOwnershipBaseUrl,
    UsersBaseUrl, getClientForOrganizationUrl,
    AdvertiserLoginPartnersUrl
} from "../config/generals";
import {IOwnership} from "@leap4/general-common";
import {IOrganizationAdvertiserLogin} from "../components/organizations/interfaces/IOrganizationAdvertiserLogin";
import {IFormData} from "../components/users/AddEditUser/AddUser";
import {IPublisherLogins} from "../components/publisherLogins/interfaces/IPublisherLogins";
import {CreateClientDto} from "../components/organizations/Organization/Client/IClient";



export const getAllOrganizations = async (dispatch: Dispatch) => {
    try {
        const res = await ApiClient.get( OrganizationsBaseUrl );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const getClientForOrganization = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.get( getClientForOrganizationUrl + "/" + id);
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const postNewClient = async (
    dispatch: React.Dispatch<any>,
    dto: CreateClientDto
) => {
    try {
        const res = await ApiClient.post(getClientForOrganizationUrl, dto);
        return res.data;
    } catch (err: any) {
        dispatch({ type: USER_ERROR, payload: {} });

        setAlert(
            err.response?.data?.message || "Couldn't create client",
            AlertTypes.FAILURE
        );
        return null;
    }
};

export const regenerateClient = async (
    dispatch: React.Dispatch<any>,
    organizationId: string,
) => {
    try {
        const res = await ApiClient.post(
            `${getClientForOrganizationUrl}/${organizationId}/regenerate`,
        );
        return res.data;
    } catch (err: any) {
        dispatch({ type: USER_ERROR, payload: {} });
        dispatch(
            setAlert(
                err.response?.data?.message || "Couldn't regenerate client",
                AlertTypes.FAILURE,
            ) as any,
        );
        return null;
    }
};

export const getAllTags = async (dispatch: Dispatch, date: Date, id: string) => {
    try {
        const res = await ApiClient.post( ownershipsSupply,{Date: date, id: id} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const addOwnershipToDB = async (dispatch: Dispatch, ownership: IOwnership) => {
    try {
        const res = await ApiClient.post( AddOwnershipBaseUrl,{ownership} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const submitAndDeleteOrganization = async (dispatch: Dispatch, organization: IOrganizationAdvertiserLogin) => {
    try {
        const res = await ApiClient.post( OrganizationsSubmitChanges,{organization: organization} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const updatePartners = async (dispatch: Dispatch, publisherLogins: IPublisherLogins) => {
    try {
        const res = await ApiClient.post( OrganizationsUpdatePartners,{publisherLogins: publisherLogins} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const updateAdvertiserLoginPartners = async (
    dispatch: Dispatch,
    body: {
        organizationId: string,
        advertiserLoginId: string,
        partners: { id: string, name: string }[]
    }
) => {
    try {
        const res = await ApiClient.post(AdvertiserLoginPartnersUrl, body);
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't update advertiser login partners", AlertTypes.FAILURE);
    }
}

export const createNewOrganization = async (dispatch: Dispatch, name: string) => {
    try {
        const res = await ApiClient.post( createNewOrganizationUrl,{name: name} );
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const getUserById = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.get( UsersBaseUrl + "/" + id);
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const updateUserId = async (dispatch: Dispatch, id: string, organizations: string[]) => {
    try {
        const res = await ApiClient.post( UsersBaseUrl + "/submit", {userId: id, organizations: organizations});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const createUser = async (dispatch: Dispatch, user: IFormData) => {
    try {
        const res = await ApiClient.post( UsersBaseUrl + "/create", {user: user});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}

export const deleteOwnership = async (dispatch: Dispatch, id: string) => {
    try {
        const res = await ApiClient.post( deleteOwnershipUrl, {id: id});
        return res.data;
    } catch (err) {
        dispatch({
            type: USER_ERROR,
            payload: {},
        });

        setAlert("Couldn't fetch organizations", AlertTypes.FAILURE);
    }
}